import React from "react";
import { Card } from "@tennr/frontend/components/Card";
import "./BlockQuote.css";

interface BlockQuoteProps {
  children: React.ReactNode;
  author?: string;
  role?: string;
  variant?: "default" | "case-study";
}

export const BlockQuote: React.FC<BlockQuoteProps> = ({ children, author, role, variant = "case-study" }) => {
  // Use variant prop if provided, otherwise check DOM
  const isCaseStudy =
    variant === "case-study" ||
    (typeof document !== "undefined" && document.querySelector(".case-study-detail-content-section"));

  return (
    <Card>
      <blockquote className="case-study-detail-content-quote">
        <div className="block-quote-content">{children}</div>
        {(author || role) && (
          <cite style={{ fontSize: "12px", lineHeight: "16.2px" }}>
            {author && <span>{author}</span>}
            {role && <span>{role}</span>}
          </cite>
        )}
      </blockquote>
    </Card>
  );
};
